import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CompanyExternalIdResponse } from '@/repositories/generated';

const response: CompanyExternalIdResponse[] = [
  {
    externalId: 'company001',
  },
  {
    externalId: 'company002',
  },
  {
    externalId: 'company003',
  },
];

export const autocompleteExternalCompanyId = http.get(
  createMockEndpoint('/autocomplete/company/externalId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
